import React from 'react';
import PropTypes from 'prop-types';
import Form from '../containers/SubscriptionPlanForm';

const EditSubscriptionPlan = ({ onSubmit, onDelete, initialValues }) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <h2 className="c-heading c-heading--lightgrey u-mb">Edit Subscription Plan</h2>
        <Form onSubmit={onSubmit} onDelete={onDelete} initialValues={initialValues} />
      </div>
    </div>
  </div>
);
EditSubscriptionPlan.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
};

export default EditSubscriptionPlan;
